import schema from "../../gen/schema/witbooking.backoffice.taxation.v1/Taxation.json";

export let modifiedSchema = schema;
// @ts-ignore
modifiedSchema.properties.typologyModule = {
  properties: {
    typology: {
      enum: [
        "PER_PERSON",
        0,
        "PER_PERSON_PER_NIGHT",
        1,
        "PER_STAY",
        2,
        "PER_STAY_PER_NIGHT",
        3,
        "PERCENTAGE",
        4,
        "BALEARIC",
        5,
      ],
    },
    amount: {
      type: "number",
    },
    minAge: {
      type: "number",
    },
    typeOfTaxation: {
      type: "string",
    },
    maxNights: {
      type: "number",
    },
    maxAmount: {
      type: "number",
    },
  },
  type: "object",
};

// @ts-ignore
modifiedSchema.properties.taxPreferenceModule = {
  properties: {
    preference: {
      enum: ["INCLUDED", 0, "EXCLUDED", 1, "INCLUDED_IN_CHECKOUT", 2],
    },
  },
  type: "object",
};

// @ts-ignore
modifiedSchema.properties.validitySection = {
  type: "string",
};

// @ts-ignore
modifiedSchema.properties.thresholdModule = {
  properties: {
    startAt: {
      type: "string",
      format: "date-time",
    },
    endAt: {
      type: "string",
      format: "date-time",
    },
  },
  type: "object",
};

// @ts-ignore
modifiedSchema.properties.typology = { type: "number" };
// @ts-ignore
modifiedSchema.properties.preference = { type: "number" };
// @ts-ignore
modifiedSchema.properties.threshold = { type: "object" };
// @ts-ignore
modifiedSchema.properties.createdAt = { type: "object" };

// @ts-ignore
modifiedSchema.properties.restrictionsSection = { type: "string" };
// @ts-ignore
modifiedSchema.properties.maxNights = { type: "number" };
// @ts-ignore
modifiedSchema.properties.maxAmount = { type: "number" };
// @ts-ignore
modifiedSchema.properties.type = { type: "string" };
// @ts-ignore
modifiedSchema.properties.updatedAt = { type: "object" };

modifiedSchema.properties.translations.items.properties = {
  ...modifiedSchema.properties.translations.items.properties,
  title: {
    ...modifiedSchema.properties.translations.items.properties.title,
    // @ts-ignore
    maxLength: 32,
  },
};
